const presetItemList = [
  {
    id: 1,
    name: 'office',
    items: [0, 2, 5, 9, 10],
  },
  {
    id: 2,
    name: 'living',
    items: [5, 10, 14, 16],
  },
  {
    id: 3,
    name: 'entertainment',
    items: [2, 5, 10, 15, 17],
  },
  {
    id: 4,
    name: 'store',
    items: [1, 3, 13],
  },
  {
    id: 5,
    name: 'medical',
    items: [0, 4, 12],
  },
  {
    id: 6,
    name: 'transit',
    items: [6, 7, 8],
  },
];

export default presetItemList;
